
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"13"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill",attrs:{"fill-rule":"evenodd","d":"M15 4.086v6.646c0 .737-.603 1.34-1.34 1.34H1.34c-.737 0-1.34-.603-1.34-1.34V4.086c.251.276.536.519.845.728 1.39.946 2.796 1.892 4.16 2.888.704.519 1.574 1.155 2.487 1.155h.016c.913 0 1.783-.636 2.486-1.155a160.816 160.816 0 014.169-2.888A4.93 4.93 0 0015 4.086zm0-2.461c0 .937-.695 1.783-1.431 2.294-1.306.904-2.62 1.808-3.918 2.72-.544.377-1.465 1.147-2.143 1.147h-.016c-.678 0-1.6-.77-2.143-1.147-1.298-.912-2.612-1.816-3.91-2.72C.846 3.517 0 2.57 0 1.809 0 .99.444.286 1.34.286h12.32c.729 0 1.34.602 1.34 1.339z"}})])
          )
        }
      }
    